import { api } from "./api";

export const loadRazorpay = () => new Promise((resolve, reject) => {
  if (window.Razorpay) return resolve();
  const s = document.createElement("script");
  s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = resolve;
  s.onerror = () => reject(new Error("Could not load Razorpay checkout"));
  document.body.appendChild(s);
});

export const createOrder = async (product) => (await api.post("/payments/orders", { product })).data;

export const completeMock = async (order) => (await api.post(`/payments/mock/complete?merchant_order_id=${order.merchant_order_id}`)).data;

// Razorpay success is only trusted after the backend verifies the signature.
export const payWithRazorpay = async (order) => {
  await loadRazorpay();
  return new Promise((resolve, reject) => {
    const rz = new window.Razorpay({
      key: order.razorpay_key_id, order_id: order.provider_order_id, amount: order.amount_minor, currency: order.currency,
      name: "AVAILITY", description: order.certification_title,
      prefill: { name: order.user_name, email: order.user_email },
      theme: { color: "#15365F" },
      // Mobile UPI/netbanking may leave the page; Razorpay then posts back here and the server verifies the signature.
      callback_url: `${process.env.REACT_APP_BACKEND_URL}/api/payments/razorpay/callback`,
      redirect: false,
      handler: async (res) => {
        // Retry so a brief backend restart doesn't strand a completed payment.
        for (let i = 0; i < 4; i += 1) {
          try { return resolve((await api.post("/payments/razorpay/verify", res)).data); }
          catch (e) {
            const transient = !e.response || e.response.status >= 500;
            if (!transient || i === 3) { e.verifyFailed = transient; return reject(e); }
            await new Promise((r) => setTimeout(r, 2500 * (i + 1)));
          }
        }
      },
      modal: { ondismiss: () => reject(new Error("Payment was cancelled")) },
    });
    rz.open();
  });
};
